<div class="row mx-auto align-items-center login-body">
  <div class="col-12 col-sm-6 col-md-4 mx-auto my-auto">
    <div class="card text-center">
      <div class="d-flex flex-column card-body login-box">
        <!-- logo area -->
        <div class="image-box">
          <img class="image-sams-login" oncontextmenu="return false" [src]="'/assets/images/logo-footer.svg'" />
        </div>

        <!-- message area -->
        <div class="message-box my-auto">
          <div [ngClass]="{'alert alert-danger': error}" class="mb-0">{{ message }}</div>
          @if (!error) {
            <div class="spinner-border custom-spinner" role="status" aria-hidden="true"></div>
          }
        </div>

        <!-- buttons area -->
        @if (error) {
          <div class="mb-auto d-flex flex-column align-items-center buttons-box">
            <div class="btn-group-vertical">
              @if (!concurrentLogin && directChannel) {
                <button class="btn btn-primary login-btn retry-btn" (click)="onRetryLogin()"
                  translate>
                  generic.retry
                </button>
                <h5><span translate>login.or</span></h5>
              }
              @if (concurrentLogin) {
                <button class="btn btn-primary login-btn continue-btn" (click)="onContinueLogin()"
                  translate>
                  generic.continue
                </button>
                <h5><span translate>login.or</span></h5>
              }
              
              @if (error) {
                 <button type="button" class="btn btn-primary" (click)="goToHelpDesk()" translate>
                    CONTATTA L'HELP DESK
                  </button>
              }
              @if (!error) {
                <button class="btn btn-primary login-btn return-btn" (click)="onReturnLoginPage()" translate>
                  generic.login-with-credentials
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
